import moment from "moment";
import jwtDecode from "jwt-decode";
import axios from "axios";

interface JwtPayload {
  role: string[];
  email?: string;
  sub?: string;
  name?: string;
  exp?: number;
  iat?: number;
}

export const spiltStringAndGetLastIndex = (data: any) => {
  let splitData = data?.toString()?.split("-");
  return splitData[splitData?.length - 1];
};

export const getLastDigitFromUserId = (userId: any) => {
  const userIdString = userId?.toString() || "";
  const parts = userIdString.split("-");
  const lastElement = parts.length > 1 ? parts[parts.length - 1] : userIdString;

  return lastElement;
};

export const getFormattedDate = (date: any) => {
  try {
    const formattedDateTime = moment(date).format("DD MMM, YYYY, hh:mm A");
    return formattedDateTime;
  } catch (e) {
    return "invalid date format";
  }
};

export const getUserRole = (token: string): string[] => {
  try {
    const decodedToken = jwtDecode<JwtPayload>(token);
    return decodedToken.role || [];
  } catch (error) {
    console.error("Failed to decode JWT token:", error);
    return [];
  }
};

export const getUserInfo = (token: string): any => {
  try {
    const decodedToken = jwtDecode<JwtPayload>(token);
    return decodedToken || {};
  } catch (error) {
    console.error("Failed to decode JWT token:", error);
    return {};
  }
};

export const getFileNameFromUrl = (url: string) => {
  const segments = new URL(url)?.pathname?.split("/");
  return segments?.pop() || "";
};

export const downloadFileFromS3 = (s3Url: string) => {
  if (s3Url) {
    // Create an anchor element
    let fileName = getFileNameFromUrl(s3Url);
    const anchor = document.createElement("a");

    // Set the anchor's href to the S3 URL
    anchor.href = s3Url;

    // Set the desired file name for the download
    anchor.download = fileName || "download";

    // Append the anchor to the document
    document.body.appendChild(anchor);

    // Programmatically trigger a click event on the anchor
    anchor.click();

    // Remove the anchor element after the download is triggered
    document.body.removeChild(anchor);
  }
};

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth"
  });
};

export const getUserEmail = async (): Promise<string> => {
  try {
    const accessToken = localStorage.getItem("accessToken") || "";
    console.log("Access token available:", !!accessToken);

    // First try to get email from JWT token
    const decodedToken = jwtDecode<JwtPayload>(accessToken);
    console.log("Decoded token:", decodedToken);
    if (decodedToken.email) {
      console.log("Email found in token:", decodedToken.email);
      return decodedToken.email;
    }

    console.log("Email not found in token, trying API...");
    // If email not in token, fetch from API
    const apiEndpoint = process.env.REACT_APP_API_BASE_URL;
    const response = await axios.get(
      `${apiEndpoint}/users/support/user/email`,
      {
        headers: {
          Authorization: `bearer ${accessToken}`,
          "Content-Type": "application/json"
        }
      }
    );

    console.log("API response:", response.data);
    return response.data?.email || "support@rewardle.com";
  } catch (error) {
    console.error("Failed to get user email:", error);
    return "support@rewardle.com"; // fallback email
  }
};
